// segmentTemplates.js
//
// Pre-built segment ruleTrees marketers can start from. Solves the "what
// should I build first?" problem — most first-time users need a scaffold
// before they understand the field catalog.
//
// Rendered by segments/components/TemplatePicker.jsx when a new segment has
// no rules yet. Clicking a template drops its ruleTree (and optionally its
// name/description) into the editor state.

export const SEGMENT_TEMPLATES = [
    {
        id: 'winback_churned_vips',
        name: 'Win back churned VIPs',
        description: 'VIP customers who haven\'t booked in over 90 days.',
        icon: 'crown',
        ruleTree: {
            match: 'all',
            rules: [
                { field: 'vipCohort', op: 'eq', value: true },
                { field: 'lastOrderDaysAgo', op: 'gt', value: 90 },
            ],
        },
    },
    {
        id: 'welcome_new_users',
        name: 'Welcome new users',
        description: 'Signed up in the last 7 days and never booked.',
        icon: 'sparkles',
        ruleTree: {
            match: 'all',
            rules: [
                { field: 'registeredDaysAgo', op: 'lte', value: 7 },
                { field: 'totalOrders', op: 'eq', value: 0 },
            ],
        },
    },
    {
        id: 'cart_abandon_1h',
        name: 'Cart abandoners',
        description: 'Users currently in checkout with an open cart.',
        icon: 'shopping-cart',
        ruleTree: {
            match: 'all',
            rules: [
                { field: 'checkoutStartedAt', op: 'exists' },
            ],
        },
    },
    {
        id: 'lapsed_subscribers',
        name: 'Lapsed subscribers',
        description: 'Had a subscription that already ended.',
        icon: 'refresh-ccw',
        ruleTree: {
            match: 'all',
            rules: [
                { field: 'hasActiveSubscription', op: 'eq', value: false },
                { field: 'subscriptionExpiresAt', op: 'exists' },
            ],
        },
    },
    {
        id: 'wallet_expiring_soon',
        name: 'Wallet credit expiring this week',
        description: 'Users with credit expiring in the next 7 days.',
        icon: 'wallet',
        ruleTree: {
            match: 'all',
            rules: [
                { field: 'expiringWalletInDays', op: 'lte', value: 7 },
                { field: 'walletBalance', op: 'gt', value: 0 },
            ],
        },
    },
    {
        id: 'dubai_high_value',
        name: 'High-value Dubai regulars',
        description: 'LTV >= 1000 AED with a saved place in Dubai.',
        icon: 'star',
        ruleTree: {
            match: 'all',
            rules: [
                { field: 'lifetimeValue', op: 'gte', value: 1000 },
                { field: 'allEmirates', op: 'contains', value: 'Dubai' },
            ],
        },
    },
    {
        id: 'dormant_recent',
        name: 'Dormant — nudge back',
        description: 'Last booked between 30 and 60 days ago.',
        icon: 'clock',
        ruleTree: {
            match: 'all',
            rules: [
                { field: 'lastOrderDaysAgo', op: 'between', value: [30, 60] },
            ],
        },
    },
    {
        id: 'suv_owners',
        name: 'SUV owners',
        description: 'Users with at least one SUV — good for a premium-wash upsell.',
        icon: 'car',
        ruleTree: {
            match: 'all',
            rules: [
                { field: 'vehicleTypes', op: 'contains', value: 'SUV' },
            ],
        },
    },
];

export const getTemplate = (id) => SEGMENT_TEMPLATES.find(t => t.id === id) || null;
